/**
 * 模版市场-小游戏盒子组件
 * @author honggexuan
 * @since 19/03/18
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import QRCode from '@fe/common/lib/qrcode';
import { sendStat } from 'utils/common';
import Stat from '@fe/common/lib/stat';

// 加载失败的备用图
import PLACE_HOLDER_IMG from 'assets/images/placeholder.png';

import './game-box.less';

// 二维码配置
const QRCODE_CONFIG = {
  // 宽度
  width: 130,
  // 高度
  height: 130,
  // 前景色
  colorDark: '#000000',
  // 背景色
  colorLight: '#ffffff',
};

class GameBox extends Component {
  static propTypes = {
    container: PropTypes.object,
    tpl: PropTypes.object,
    onClickBox: PropTypes.func,
  };

  state = {
    showMaskFlag: false,
  };

  componentDidMount() {
    const { cover } = this.props.tpl;
    setTimeout(() => {
      this.preloadCover(this.coverImg, cover);
    }, 0);
  }

  // 封面预加载
  preloadCover = (node, cover) => {
    const preloadImg = new Image();
    preloadImg.onload = () => {
      setTimeout(() => {
        if (node) {
          node.setAttribute('src', cover);
          node.onload = () => {
            node.classList.add('success');
          };
        }
      }, 200);
    };

    preloadImg.src = cover;
  };

  // 点击立即使用按钮
  handleClick = () => {
    // 小游戏运营埋点
    sendStat('RP_STORE', '模版市场', '小游戏中间页', Stat.ACTION_CLICK, {
      id: 'web_mobanmarket_gamepage_preview',
    });
    this.props.onClickBox();
  };

  // 显示二维码
  showQrCode = () => {
    const { previewUrl } = this.props.tpl;
    const canvas = this.qrCode.querySelector('canvas');

    // 生成二维码
    if (!canvas) {
      new QRCode(this.qrCode, {
        ...QRCODE_CONFIG,
        text: previewUrl || 'https://www.rabbitpre.com/',
      });
    }
  };

  // 显示蒙层
  showMask = () => {
    this.showQrCode();
    this.setState({
      showMaskFlag: true,
    });
  };

  // 隐藏蒙层
  hideMask = () => {
    this.setState({
      showMaskFlag: false,
    });
  };

  render() {
    if (!this.props.container) return null;
    const { id, type, name } = this.props.tpl;
    const { showMaskFlag } = this.state;
    return (
      <div
        className={`tpl-box ${type}`}
        data-tpl-id={id}
        onMouseEnter={this.showMask}
        onMouseLeave={this.hideMask}>
        <div className="game-wrapper">
          <div className="game-cover">
            <img src={PLACE_HOLDER_IMG} ref={node => (this.coverImg = node)} />
          </div>
          <div className="game-name">{name}</div>
        </div>
        <div
          className={classnames('mask', {
            show: showMaskFlag,
          })}>
          <div className="qr-code" ref={node => (this.qrCode = node)} />
          <button className="create-btn" onClick={this.handleClick}>
            开始制作
          </button>
        </div>
      </div>
    );
  }
}

export default GameBox;
